import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import DescriptionIcon from '@mui/icons-material/Description';
import { ThreeDots } from 'react-loader-spinner';
import SftGlobalData from '../library/globalData';
import './Menu.css';

// Application icon mapping
const applicationIcons = {
    'mysales': '/assets/application-icons/ic_mysales.png',
    'myfashionmanager': '/assets/application-icons/ic_office.png',
    'myoffice': '/assets/application-icons/ic_office.png',
    'mysofttouch': '/assets/application-icons/ic_mysft.png',
    'mysft': '/assets/application-icons/ic_mysft.png',
    'webshop': '/assets/application-icons/ic_webshop.png',
    'myfasmanmobile': '/assets/application-icons/ic_mobile.png',
    'myfasmanrevenue': '/assets/application-icons/ic_revenue.png',
};

const getApplicationIcon = (appName) => {
    const key = appName?.toLowerCase().replace(/\s+/g, '');
    console.log("getApplicationIcon - key:", key);
    return applicationIcons[key] || null;
};

function Menu({ language }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [menuItems, setMenuItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [expandedItems, setExpandedItems] = useState({});

    // Extract docId from URL path
    const getCurrentDocId = () => {
        const match = location.pathname.match(/\/document\/(\d+)/);
        return match ? match[1] : null;
    };
    const currentDocId = getCurrentDocId();

    console.log('Menu - currentDocId:', currentDocId, 'path:', location.pathname);

    useEffect(() => {
        fetchMenuItems();
    }, [language]);

    const fetchMenuItems = async () => {
        setLoading(true);
        const response = await SftGlobalData.post('docs&action=fetchUpdates', {
            language: language.toUpperCase()
        });

        if (SftGlobalData.debug) {
            console.log('Menu fetchUpdates response:', response);
        }

        if (response.success && response.data) {
            setMenuItems(Array.isArray(response.data) ? response.data : []);
        } else {
            console.warn('Failed to fetch menu items:', response);
            setMenuItems([]);
        }
        setLoading(false);
    };

    const toggleExpand = (index) => {
        setExpandedItems(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    const handleDocumentClick = (docId) => {
        navigate(`/${language}/document/${docId}`);
    };

    const getTitleByLanguage = (item) => {
        switch (language) {
            case 'en':
                return item.title_en || item.title_nl || item.application;
            case 'fr':
                return item.title_fr || item.title_nl || item.application;
            default:
                return item.title_nl || item.application;
        }
    };

    if (loading) {
        return (
            <div className="menu-loading">
                <ThreeDots color="#0071BB" height={40} width={40} />
            </div>
        );
    }

    return (
        <nav className="menu">
            {menuItems.map((item, index) => (
                <div key={index} className="menu-category">
                    <button
                        className="menu-category-header"
                        onClick={() => toggleExpand(index)}
                    >
                        <div className="menu-category-title">
                            {getApplicationIcon(item.application) && (
                                <img
                                    src={getApplicationIcon(item.application)}
                                    alt=""
                                    className="menu-category-icon"
                                />
                            )}
                            <span>{item.application}</span>
                        </div>
                        {expandedItems[index] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </button>

                    {expandedItems[index] && item.versions && (
                        <ul className="menu-items">
                            {item.versions.map((version, vIndex) => (
                                <li key={vIndex}>
                                    <button
                                        className={`menu-item ${String(version.doc_id) === String(currentDocId) ? 'active' : ''}`}
                                        onClick={() => handleDocumentClick(version.doc_id)}
                                    >
                                        <DescriptionIcon className="menu-item-icon" />
                                        <span>{getTitleByLanguage(version)}</span>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            ))}
        </nav>
    );
}

export default Menu;
